<template>
  <div class="custom-locations-container">
    <save-custom-location />
  </div>
</template>

<script setup lang="ts">
import { defineAsyncComponent } from 'vue';

import util from '@/Utils/util';

const SaveCustomLocation = defineAsyncComponent(() => import('./CustomLocations/SaveCustomLocation.vue') as any);

util.moveToTop();
</script>
